export const RETAIL_EVENTS = [
  'Halloween',
  'Christmas/Holidays',
  "Valentine's Day",
  'Easter',
  'Thanksgiving',
  "New Year's",
  "St. Patrick's Day",
  'Pride Month',
  'Black History Month',
  'Lunar New Year',
  'Día de los Muertos',
  'Diwali',
  'Olympics',
  'Super Bowl',
  'World Cup',
  'March Madness',
  'Back to School',
  'Summer Collection',
  'Spring Drop',
  'Black Friday/Cyber Monday'
]
